/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
let eventDelayActive = false;

export const setEventDelayActive = (isEventDelayActive: boolean): void => {
	eventDelayActive = isEventDelayActive;
};

export const isEventDelayActive = (): boolean => eventDelayActive;
